<template>
  <v-dialog v-model="show" max-width="600px" persistent v-if="localAccess">
    <v-card>
      <v-card-title>
        <div>
          <h3>
            {{ $t("Manage_Installers.AddNewFusionSolarAccess") }}
          </h3>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon v-on:click.native="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-3"></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" v-model="valid">
                <v-text-field
                  :label="$t('Manage_Installers.UserName')"
                  v-model="localAccess.userName"
                  :rules="[v => !!v || $t('Rules.Username_required')]"
                ></v-text-field>
                <v-text-field
                  :label="$t('Manage_Installers.Password')"
                  v-model="localAccess.password"
                  :rules="[v => !!v || $t('Rules.Password_required')]"
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text v-on:click="show = false">{{ $t("Generic.Cancel") }}</v-btn>
        <v-btn text :color="'green'" :disabled="!valid" v-on:click="addAccess"
          >{{ $t("Generic.Add") + " " + localAccess.userName }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      localAccess: undefined,
      valid: false
    };
  },
  props: {
    value: Boolean
  },
  methods: {
    addAccess() {
      if (this.$refs.form.validate()) {
        this.$emit("add-access", this.localAccess);
      }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.localAccess = {
          userName: "",
          password: ""
        };
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
